import { action } from 'satcheljs';

const executeSearch = action('executeSearch', (queryString: string, messageBody: string) => ({
    queryString: queryString,
    messageBody: messageBody,
}));

export default executeSearch;
